var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsUUID, MaxLength } from 'class-validator';
import { UserFullSizeDto } from '../../user/index.js';
import { CreateOfficeLocationDto } from './create-office-location.dto.js';
export class CreateOfficeDto {
    isActive;
    users;
    mainAdminId;
    officeLocations;
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateOfficeDto.prototype, "isActive", void 0);
__decorate([
    IsArray(),
    Type(() => UserFullSizeDto),
    IsOptional(),
    __metadata("design:type", Array)
], CreateOfficeDto.prototype, "users", void 0);
__decorate([
    IsUUID(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateOfficeDto.prototype, "mainAdminId", void 0);
__decorate([
    IsArray(),
    Type(() => CreateOfficeLocationDto),
    IsOptional(),
    __metadata("design:type", Array)
], CreateOfficeDto.prototype, "officeLocations", void 0);
//# sourceMappingURL=create-office.dto.js.map